import React, { useEffect, useState } from "react";
import colors from "../../../Utils/colors";
import { Form } from "react-bootstrap";
import { Autocomplete, TextField } from "@mui/material";
import { getClientAttributes } from '../../../Services';
import { useSelector } from "react-redux";
import { CarouselPreview, RichCardPreview, TextTemplatePreview } from "../../RCSCampaign/RCSCampaignModal";

interface Suggestion {
    suggestionType: string;
    text: string;
    postbackData?: string;
    url?: string;
    application?: string;
}

interface StandaloneCard {
    cardTitle: string;
    cardDescription?: string;
    mediaUrl?: string;
    suggestions?: Suggestion[];
}

interface CarouselCard {
    cardTitle: string;
    cardDescription?: string;
    mediaUrl?: string;
    suggestions?: Suggestion[];
}

interface RCSItem {
    name: string;
    type: "richcard" | "text" | "carousel";
    botId: string;
    orientation?: string;
    height?: string;
    standaloneCard?: StandaloneCard;
    carouselCard?: CarouselCard[];
    textMessage?: string;
    suggestions?: Suggestion[];
    variables?: string[];
    status: string;
    lastUpdate: string;
}

interface RCSDetailsProps {
    item: RCSItem;
    setRCSVariables: (variables: string[]) => void;
}

interface AttributeOption {
    _id: string;
    attribute: string;
    [key: string]: any;
}

export default function RCSDetails({
    item,
    setRCSVariables,
}: RCSDetailsProps) {

    const [attributesList, setAttributesList] = useState(['name', 'email', 'phone', 'createdAt', 'updatedAt']);
    const authtoken = useSelector((state: any) => state.main.auth_token);
    const [inputField, setInputField] = useState(
        item.variables?.map(() => ({ variable: "" })) || []
    );


    const getUserAttributesAPICall = () => {
        if (!authtoken) return;

        const maybePromise = getClientAttributes(authtoken);

        if (maybePromise) {
            maybePromise.then((res: any) => {
                if (res?.flag) {
                    setAttributesList((prev) => {
                        const arr = res?.data?.map((item: any) => item?.attribute) || [];
                        return [...prev, ...arr];
                    });
                }
            });
        }
    };

    useEffect(() => {
        getUserAttributesAPICall();
    }, []);

    useEffect(() => {
        setRCSVariables(inputField.map((v) => v.variable));
    }, [inputField]);

    return (
        <div style={{ display: "flex", gap: 20, width: "100%", overflow: "hidden", height: "100%" }}>
            {/* LEFT: Header editor */}
            <div
                style={{
                    flex: 1,
                    background: "#fff",
                    border: "1px solid #E5E7EB",
                    borderRadius: 8,
                    padding: 16,
                }}
            >
                <h4 style={{ margin: "8px 0", fontSize: 14, fontWeight: 600 }}>
                    Map Variables
                </h4>

                <p
                    style={{
                        width: '100%',
                        margin: 0,
                        padding: 0,
                        marginBlock: 8,
                        fontSize: 16,
                        fontWeight: 400,
                        color: colors.greys04,
                    }}
                >
                    {`%name% is the value used for dynamically adding the customer name to the variable. In case your first variable isn't name, then replace %name% with the word you would like to send for variable 1 `}
                </p>


                {item.variables?.map((v, index) => (

                    v !== '' && (
                        <div key={v} style={{ marginBottom: 12 }}>
                            <Form.Label
                                style={{ fontSize: 14, fontWeight: 600, color: "#111827" }}
                            >
                                {`{{${v}}}`}
                            </Form.Label>

                            <Autocomplete<AttributeOption | string>
                                disablePortal
                                options={attributesList} // array of objects
                                getOptionLabel={(option) =>
                                    typeof option === "string" ? option : option?.attribute || ""
                                }
                                value={inputField[index]?.variable || ""}
                                onInputChange={(e, newValue) => {
                                    setInputField((prev) => {
                                        const tempObj = [...prev];
                                        tempObj[index].variable = newValue;
                                        return tempObj;
                                    });
                                }}
                                onChange={(e, newValue) => {
                                    setInputField((prev) => {
                                        const tempObj = [...prev];
                                        tempObj[index].variable = newValue ? `%${newValue}%` : '';
                                        return tempObj;
                                    });
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder={`Enter static or choose e.g. %${v}%`}
                                        size="small"
                                        InputProps={{
                                            ...params.InputProps,
                                            notched: false,
                                            style: { borderRadius: 8 },
                                        }}
                                    />
                                )}
                                style={{ width: "100%" }}
                            />
                        </div>
                    )

                ))}



            </div>

            {/* RIGHT: Preview */}
            <div
                style={{
                    flex: 1,
                    background: "#242226",
                    borderRadius: 8,
                    padding: 16,
                    color: "white",
                    overflow: "hidden",
                    height: "90%",
                }}
            >
                <div className="fw-bold mb-2 text-center">Message Preview</div>
                <div style={{ height: "100%", overflow: "auto" }} className="d-flex justify-content-center align-items-center">
                    {item?.type === "richcard" && (
                        <RichCardPreview card={item.standaloneCard} />
                    )}
                    {item?.type === "carousel" && (
                        <CarouselPreview carouselCard={item.carouselCard} />
                    )}
                    {item?.type === "text" && (
                        <TextTemplatePreview
                            textMessage={item.textMessage}
                            suggestions={item.suggestions}
                        />
                    )}
                </div>
            </div>

        </div>
    );
}
